import { component } from "picoapp";

export default component(async (node) => {
  const [{ default: KeenSlider }] = await Promise.all([
    import("keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderElement = node.querySelector(".keen-slider");
  // eslint-disable-next-line no-new
  new KeenSlider(sliderElement, {
    loop: true,
    slides: { perView: 1.5, spacing: 12 },
    breakpoints: {
      "(min-width: 750px)": {
        disabled: true,
      },
    },
  });
});
